import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapCreateCostCenterFromTransport, mapCreateCostCenterToTransport } from '../mappers';
import type { CreateCostCenterRequest, CreateCostCenterResult, LC_CreateCostCenterOut } from '../types';


export class CostCenterCreateService {
  async create(request: CreateCostCenterRequest): Promise<ApiResponse<CreateCostCenterResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.COST_CENTERS;
    const payload = mapCreateCostCenterToTransport(request);
    const response = await apiClient.post<LC_CreateCostCenterOut>(endpoint, payload);
    if (response.success && response.data) {
      return { ...response, data: mapCreateCostCenterFromTransport(response.data) };
    }
    return { ...response, data: null };
  }
}

export const costCenterCreate = new CostCenterCreateService();
